import React, { FC } from 'react'
import { Box, Collapse, Typography, useTheme } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { TimeLineBlockStruct, TimeLineBlock } from './TimelineBlock'

interface TimeLineProps {
  blocks: TimeLineBlockStruct[]
  CollapsedContent?: React.ReactElement
}

export const TimeLine: FC<TimeLineProps> = ({ blocks, CollapsedContent }) => {
  const [open, setOpen] = React.useState(true)
  const theme = useTheme()

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box
        sx={{
          marginBottom: open ? 8 : 2,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
        onClick={() => setOpen(!open)}
        component={'div'}
      >
        <Typography variant="bodyMuted">Timeline</Typography>
        {open ? (
          <ExpandLess htmlColor={theme.typography.bodyMuted?.color} />
        ) : (
          <ExpandMore htmlColor={theme.typography.bodyMuted?.color} />
        )}
      </Box>
      <Collapse in={open}>
        {blocks.map((block: TimeLineBlockStruct, idx: number) => {
          return <TimeLineBlock key={idx} block={block} theme={theme} isLast={idx === blocks.length - 1} />
        })}
      </Collapse>
      {!open && CollapsedContent && CollapsedContent}
    </Box>
  )
}
